import { Screen, useNavigation } from '@bonanza-social/navigation';
import { memo, useEffect } from 'react';
import PersonalInfo from '../components/MyProfile/PersonalInfo';
import LoginInfo from '../components/MyProfile/LoginInfo';
import { Box, KeyboardShift } from '@bonanza-social/moonlight';
import CloseAccount from '../components/MyProfile/CloseAccount';
import { useTranslation } from '@bonanza-social/i18n';

function MyProfileScreen() {
  const navigation = useNavigation();
  const { t } = useTranslation('account');

  useEffect(() => {
    navigation.setOptions({ title: t('myProfileHeaderTitle') });
  }, [navigation, t]);

  return (
    <Screen paddingHorizontal="space-0" paddingBottom="safe-area-inset-bottom">
      <KeyboardShift additionalOffset={100}>
        <Box paddingHorizontal="space-400" paddingBottom="space-800">
          <LoginInfo />
          <PersonalInfo />
          <CloseAccount />
        </Box>
      </KeyboardShift>
    </Screen>
  );
}

export default memo(MyProfileScreen);
